export default __webpack_public_path__ + "static/media/doubtnut.9e7f84b6.jpg";